import { 
    CreateRouteDto, FindAutocompleteDto, HistoricDetailsResponseDto, HistoricResponseDto, 
    RouteSearchDto, SearchDto, SearchHistoricDto, SearchRouteDto, SuccessResponseDto, UpdateRouteDto 
} from "@/dtos";
import { Route } from "@/entities";
import { authHeader } from "@/helpers/utilities/auth-header";
import http from '@/helpers/apis/http-route';
import { validateToken } from "@/helpers/utilities";

class RouteService {
    async create(createRouteDto: CreateRouteDto): Promise<SuccessResponseDto<Route[]>> {
        await validateToken();
        const result = await http.post(`/admin/routes/create`,
            createRouteDto,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async search(searchDto: SearchRouteDto): Promise<SuccessResponseDto<RouteSearchDto>> {
        await validateToken();
        const result = await http.get(`/admin/routes/search`,
            { params: searchDto, headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async findAllAutocomplete(params?: FindAutocompleteDto): Promise<SuccessResponseDto<Route[]>> {
        await validateToken();
        const result = await http.get('/admin/routes/all-autocomplete',
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            });
        return result.data;
    }

    async findAllExport(searchDto: SearchRouteDto): Promise<SuccessResponseDto<Route[]>> {
        await validateToken();
        const result = await http.get('/admin/routes/all-export',
            {
                params: searchDto,
                headers: authHeader(),
                withCredentials: true
            });
        return result.data;
    }

    async findOne(id: number): Promise<SuccessResponseDto<Route>> {
        await validateToken();
        const result = await http.get(`/admin/routes/${id}`,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async update(route_id: number, updateRoute: UpdateRouteDto): Promise<SuccessResponseDto<Route[]>> {
        await validateToken();
        const result = await http.patch(`/admin/routes/update/${route_id}`,
            updateRoute,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async getHistoric(idRoute: number): Promise<SuccessResponseDto<HistoricResponseDto>> {
        await validateToken();
        const result = await http.get(`/admin/routes/historic/${idRoute}`,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async getHistoricDetails(params: SearchHistoricDto): Promise<SuccessResponseDto<HistoricDetailsResponseDto[]>> {
        await validateToken();
        const result = await http.get(`/admin/routes/historic-details`,
            {  
                params: params,
                headers: authHeader(),
                withCredentials: true 
            }
        );
        return result.data;
    }
}

export default new RouteService;